<div class="floating-label d-flex align-items-center">
    <input [formControlName]="controlName" [id]="inputId" type="checkbox" [class]="inputClass" [readOnly]="readonly" [ngClass]="{ 'no-icon': !showIcon }" autocomplete="off" />
    <label-extended-control [labelText]="labelText"></label-extended-control>
    <div *ngIf="showIcon" class="icon">
        <span [class]="iconClass"></span>
    </div>
    <div *ngIf="descriptionText" class="checkbox-description">
        <span>{{ descriptionText | translate }}</span>
    </div>
    <field-error-display-control [displayError]="parentFormHelper.showFieldError(controlName)" [errorMsg]="parentFormHelper.getErrorMessageHtml(controlName)"> </field-error-display-control>
</div>
